import React, { useEffect, useState } from "react";
import {
  Table,
  Segment,
  Loader,
  Message,
  Dropdown,
  Pagination,
} from "semantic-ui-react";
import { toast } from "react-toastify";
import config from "../../../common/repository/config";
import LocalStorage from "../../../lib/LocalStorage";

interface Doctor {
  id: string;
  name: string;
  specialization: string;
  [key: string]: any;
}

interface DownlaoedDoctorsProps {
  sync?: boolean;
  iiyy?: string;
  state?: string;
}

const yearOptions = Array.from({ length: 30 }, (_, i) => {
  const year = new Date().getFullYear() - i;
  return { key: year, value: String(year), text: String(year) };
});

const DownlaoedDoctors: React.FC<DownlaoedDoctorsProps> = ({
  sync,
  iiyy,
  state,
}) => {
  const [doctors, setDoctors] = useState<Doctor[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [year, setYear] = useState<string>(String(new Date().getFullYear()));
  const [limit] = useState<number>(40);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);

  const fetchDoctors = async () => {
    setLoading(true);
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    if (!token) {
      toast.error("Authentication token is missing.");
      setLoading(false);
      return;
    }

    try {
      const offset = (page - 1) * limit;

      const payload: any = {
        year,
        limit,
        offset,
      };

      if (state) payload.state = state;
      if (sync !== undefined) payload.sync = sync;
      if (iiyy) payload.iiyy = iiyy;

      const response = await fetch(`${config.apiBaseURL}/case/getDoctors`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();

        if (data.success && data.data && Array.isArray(data.data.items)) {
          setDoctors(data.data.items);
          setTotal(data.data.total_item_count || 0);
        } else {
          toast.error("No doctors found");
          setDoctors([]);
          setTotal(0);
        }
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || "Failed to fetch doctors");
      }
    } catch (error) {
      console.error("Error fetching doctors:", error);
      toast.error("Error fetching doctors");
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchDoctors();
  }, [year, page, sync, iiyy, state]);

  const handleYearChange = (_: any, data: any) => {
    setYear(data.value);
    setPage(1); // Reset to page 1 when year changes
  };

  const handlePageChange = (_: any, data: any) => {
    setPage(data.activePage as number);
  };

  return (
    <Segment>
      <div style={{ marginBottom: "1rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <Dropdown
            placeholder="Select Year"
            selection
            options={yearOptions}
            value={year}
            onChange={handleYearChange}
            style={{ minWidth: 150 }}
          />
        </div>
  
      </div>
      <div style={{ fontSize: "14px", color: "#4183c4", textAlign: "left", }}>
    Showing {doctors.length} of {total} doctors for year {year}
  </div>
        <>
          <Table celled striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>ID</Table.HeaderCell>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Specialization</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {doctors.map((doctor) => (
                <Table.Row key={doctor.id}>
                  <Table.Cell>{doctor.id}</Table.Cell>
                  <Table.Cell>{doctor.name}</Table.Cell>
                  <Table.Cell>{doctor.specialization || "N/A"}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>

          <div style={{ textAlign: "right", marginTop: 10 }}>
            <Pagination
              boundaryRange={1}
              siblingRange={1}
              totalPages={Math.ceil(total / limit)}
              activePage={page}
              onPageChange={handlePageChange}
              prevItem={{ content: "Prev" }}
              nextItem={{ content: "Next" }}
            />
          </div>
        </>
 
    </Segment>
  );
};

export default DownlaoedDoctors;
